module.exports = __webpack_public_path__ + "img/admin-overview.fbe36cc5.png";